import api from '@pray/shared/utils/api';

import type { RecurringPushCampaignDetail, RecurringPushCampaignStatusChangeTarget } from './types';

// PATCH …/campaigns/recurring-push/:id/status — Activate / Stop / Resume.
// Resume is `stopped → active`; the server runs activation readiness on every
// `→ active` transition. Returns the refreshed detail DTO.
export async function changeRecurringPushCampaignStatus({
  artistId,
  recurringCampaignId,
  targetStatus,
}: {
  artistId: string;
  recurringCampaignId: string;
  targetStatus: RecurringPushCampaignStatusChangeTarget;
}): Promise<{ object: RecurringPushCampaignDetail }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring-push/${recurringCampaignId}/status`;
  const response = await api.executePatchRequest<{ data: { object: RecurringPushCampaignDetail } }>(url, {
    target_status: targetStatus,
  });
  return response.data.data;
}
